<template>
  <div>
    <div class="wrapper">
      <HeaderTeacher />
      <MenuTeacher />
      <div class="content-wrapper">
        <div class="container-full">
          <section class="content">
            <div class="row align-items-end">
              <div class="col-xl-12 col-12">
                <div class="box bg-primary-light pull-up">
                  <div class="box-body p-xl-0">
                    <div class="row align-items-center">
                      <div class="col-12 col-lg-3">
                        <img
                          src="https://st.depositphotos.com/1011643/2198/i/450/depositphotos_21980059-stock-photo-elementary-school-teacher-helping-student.jpg"
                          alt
                        />
                      </div>

                      <div class="col-12 col-lg-9">
                        <h4>{{ InfosTeacher[0]['labelEtab']}}</h4>

                        <p class="text-dark mb-0 font-size-13">
                          Hi
                          <i class="fa-solid fa-hand"></i>
                          ,
                          {{users.nom }}
                          {{users.prenom }}
                        </p>

                        <h6>ENSEIGNANT(E)</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-12" v-for="(data,i) in InfosTeacher" :key="i">
                <div class="box box-slided-up">
                  <div class="box-header with-border" style="text-align: center">
                    <h4 class="box-title">
                      <strong>{{data.classe.libelleClasse}}</strong>
                    </h4>
                    <ul class="box-controls pull-right">
                      <li>
                        <a class="box-btn-close" href="#"></a>
                      </li>
                      <li>
                        <a class="box-btn-slide rotate-180" href="#"></a>
                      </li>
                      <li>
                        <a class="box-btn-fullscreen" href="#"></a>
                      </li>
                    </ul>
                  </div>

                  <div class="box-body" style="display: block;text-align: center">
                    <!-- <div class="box-body" style="display: block;">
                      <div class="dropdown">
                        <button
                          @click="SaveID(data,i)"
                          class="btn btn-rounded btn-primary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="icon ti-menu"></i>
                          Détails
                        </button>
                        <div class="dropdown-menu dropdown-menu dropdown-menu-left" style>
                          <router-link class="dropdown-item" to="listeEleveTeacher">
                            Liste des
                            éleves
                          </router-link>
                          <router-link
                            class="dropdown-item"
                            to="emploiTempTeacherForAclass"
                          >Emploi du temps</router-link>
                        </div>
                      </div>
                    </div>-->
                    <div class="callout callout-primary mb-0" role="alert">{{data.libelle}}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Chats />
  </div>
</template>

<script>
import MenuTeacher from "../../navs/MenuTeacher.vue";
import Chats from "../../navs/Chats.vue";
import { mapState } from "vuex";
import HeaderTeacher from "../../headers/HeaderTeacher.vue";

export default {
  components: { MenuTeacher, Chats, HeaderTeacher },
  data() {
    return {
      IdClasseTeacher: [],
      InfosTeacher: [],
      users: []
    };
  },

  async mounted() {
    // Recuperer les donnes de cet utulisateurs dans la storage local

    if (localStorage.users) {
      this.users = JSON.parse(localStorage.getItem("users"));

      console.log(this.users.nom);
    }

    // Allons chercher la session et le code etablissement ce cet enseigant

    const response = await this.callApi(
      "post",
      "api/locale/getInfosTeacher",
      this.users
    );

    this.InfosTeacher = response.data;

    // Garder les donnees de l'enseigant  dans le storage de navigateur

    localStorage.setItem("InfosTeacher", JSON.stringify(this.InfosTeacher));
  },

  methods: {
    SaveID(data, i) {
      localStorage.setItem("IdClasseTeacher", JSON.stringify(data));

      console.log(data);
    }
  }
};
</script>
